import React, { useContext } from "react";
import WorkProcess from "../cards/workProcess";
import { WorkProcessContext } from "../../App";
import { Workflow } from "lucide-react";

const pic = {
  url: "https://res.cloudinary.com/dkcjpdk1c/image/upload/v1751543265/22913_gm5j7b.jpg",
};

const defaultWorkProcesses = [
  {
    id: 1,
    step: 1,
    title: "Discovery & Architecture",
    description: "Deep-dive scoping, requirements gathering, and creating scalable technical architecture tailored to your business needs.",
  },
  {
    id: 2,
    step: 2,
    title: "Agile Sprint Execution",
    description: "Iterative two-week sprints with continuous stakeholder reviews, transparent progress tracking, and rapid deliverables.",
  },
  {
    id: 3,
    step: 3,
    title: "Quality Assurance & Security",
    description: "Comprehensive automated test suites, performance optimization, security checks, and rigorous code reviews.",
  },
  {
    id: 4,
    step: 4,
    title: "Deployment & Ongoing Support",
    description: "Automated CI/CD deployment, zero-downtime production release, and proactive post-launch maintenance and SLAs.",
  },
];

const WorkProcessGroup = () => {
  const workProcess = useContext(WorkProcessContext);

  const activeProcesses = Array.isArray(workProcess) && workProcess.length > 0
    ? workProcess
    : defaultWorkProcesses;

  const sortedProcesses = [...activeProcesses].sort(
    (a, b) => Number(a.step || a.id) - Number(b.step || b.id)
  );

  return (
    <section className="cht-py-14 sm:cht-py-20 cht-bg-[#f8fafc]/50 cht-border-y cht-border-slate-200/80 !cht-font-body">
      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
        
        {/* Section Header */}
        <header className="cht-text-center cht-max-w-2xl cht-mx-auto cht-mb-12 sm:cht-mb-16">
          <div className="cht-inline-flex cht-items-center cht-gap-2 cht-px-3.5 cht-py-1.5 cht-bg-blue-50 cht-border cht-border-blue-100 cht-rounded-full cht-text-xs !cht-font-bold cht-text-[#3e57da] cht-mb-4">
            <Workflow size={14} />
            <span>Execution Framework</span>
          </div>

          <h2 className="!cht-font-heading cht-text-2xl sm:cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b] cht-tracking-tight cht-mb-3">
            Our Agile Delivery Process
          </h2>

          <p className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-600 cht-leading-relaxed">
            From architecture discovery to production rollout, our structured milestones ensure predictability, quality assurance, and on-time software deployment.
          </p>
        </header>

        {/* Content Split Grid */}
        <div className="cht-grid lg:cht-grid-cols-12 cht-gap-10 lg:cht-gap-12 cht-items-center">
          
          {/* Visual Showcase (5 cols) */}
          <div className="lg:cht-col-span-5">
            <div className="cht-rounded-[24px] cht-border cht-border-slate-200/80 cht-shadow-soft cht-overflow-hidden cht-bg-white group">
              <img
                src={pic.url}
                alt="Our Delivery Workflow Process"
                className="cht-w-full cht-h-full cht-object-cover cht-transition-transform cht-duration-500 group-hover:cht-scale-[1.02]"
                loading="lazy"
              />
            </div>
          </div>

          {/* Process Step Cards (7 cols) */}
          <div className="lg:cht-col-span-7 cht-space-y-3">
            {sortedProcesses.map((item) => (
              <WorkProcess
                key={item.id}
                id={item.id}
                title={item.title}
                step={item.step}
                font_awesome_class={item.font_awesome_class}
                description={item.description}
              />
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default WorkProcessGroup;

